import { React } from "react";
import Hero from "./Hero/Hero";
import { Box } from "@mui/material";
import HomeDetails from "./Home Details/HomeDetails";
import CustomImageList from "./Custom Image List/CustomImageList";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <Box>
      <Helmet>
        <link rel="canonical" href="https://ftworthbbqcatering.com/" />
      </Helmet>
      <Hero />
      <HomeDetails />
      <CustomImageList />
    </Box>
  );
};

export default Home;
